import {
    SYSTEM_SUBMIT_WORKEXPERIENCE_BEGIN,
    SYSTEM_SUBMIT_WORKEXPERIENCE_SUCCESS,
    SYSTEM_SUBMIT_WORKEXPERIENCE_FAILURE,
    SYSTEM_SUBMIT_WORKEXPERIENCE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitWorkExperience(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_WORKEXPERIENCE_BEGIN,
      });
  
      let apiurl = '/api/b/workExperience/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/workExperience/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_WORKEXPERIENCE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_WORKEXPERIENCE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitWorkExperienceError() {
    return {
      type: SYSTEM_SUBMIT_WORKEXPERIENCE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_WORKEXPERIENCE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitWorkExperiencePending: true,
          submitWorkExperienceError: null,
        };
  
      case SYSTEM_SUBMIT_WORKEXPERIENCE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitWorkExperiencePending: false,
          submitWorkExperienceError: null,
        };
  
      case SYSTEM_SUBMIT_WORKEXPERIENCE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitWorkExperiencePending: false,
          submitWorkExperienceError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_WORKEXPERIENCE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitWorkExperienceError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitWorkExperience.js